import React, { ReactNode, MouseEvent, FunctionComponent } from 'react';
import classNames from 'classnames';
import { ColorGroupBrand, ColorGroupMono, mapColorToClassname } from 'components/enum/global';

export enum PlacardStyling {
    CELL,
    FILLED,
    FILLED_GRADIENT,
}

const mapPlacardStylingToClassname: { [key in PlacardStyling]: string } = {
    [PlacardStyling.CELL]: 'placard--cell',
    [PlacardStyling.FILLED]: 'placard--filled',
    [PlacardStyling.FILLED_GRADIENT]: 'placard--filled-gradient',
};

export enum PlacardAlign {
    CENTER,
    TOP,
}

const mapPlacardAlignToClassname: { [key in PlacardAlign]: string } = {
    [PlacardAlign.CENTER]: 'placard--align-center',
    [PlacardAlign.TOP]: 'placard--align-top',
};

export const PlacardColor = {
    BRAND: ColorGroupBrand,
    MONO: ColorGroupMono,
};

type PlacardProps = {
    media?: ReactNode;
    content: ReactNode;
    extra?: ReactNode;
    onClick?: (event: MouseEvent) => void;
    qaRole?: string;
    styling?: PlacardStyling;
    color?: ColorGroupBrand | ColorGroupMono;
    isHovered?: boolean; // for vrt purposes mostly
    isPressed?: boolean; // for vrt purposes mostly
    customColor?: string;
    align?: PlacardAlign;
};

const Placard: FunctionComponent<PlacardProps> = ({
    media,
    content,
    extra,
    onClick,
    qaRole,
    styling = PlacardStyling.CELL,
    color = ColorGroupMono.WHITE,
    align = PlacardAlign.CENTER,
    isHovered,
    isPressed,
    customColor,
}) => {
    const classnames = classNames({
        placard: true,
        [mapPlacardStylingToClassname[styling]]: true,
        [mapPlacardAlignToClassname[align]]: true,
        [mapColorToClassname[color]]: true,
        'is-clickable': onClick,
        'is-hovered': isHovered,
        'is-pressed': isPressed,
    });

    return (
        <div
            className={classnames}
            onClick={onClick}
            data-qa-role={qaRole || 'placard'}
            role={onClick ? 'button' : undefined}
            style={customColor ? { ['backgroundColor' as any]: customColor } : undefined}
        >
            {media ? (
                <div className="placard__media" data-qa-role="placard-media">
                    {media}
                </div>
            ) : null}

            <div className="placard__content" data-qa-role="placard-media">
                {content}
            </div>

            {extra ? (
                <div className="placard__extra" data-qa-role="placard-extra">
                    {extra}
                </div>
            ) : null}
        </div>
    );
};

export default Placard;
